import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import { useHudStore } from "@/domains/hud/store";

export default () => {
  const setHud = useHudStore((state) => state.setHud);

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Hud.SetHudState,
      (state: typeof RegionShared.Cef.Requests.SetHudStateRequest): void => {
        setHud(state);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Hud.SetHudState);
    };
  }, []);
};
